import {
  REQUEST_DONATION_GROUP_LIST,
  REQUEST_DONATION_GROUP
} from './mutation-types';
  
import axiosInst from '@/utility/axiosInst';
  
export default {
  requestDonationGroupList({commit}, payload) {
    const {currentPage, currentCategorySeq} = payload
    return axiosInst.springAxiosInst.get("/donation-group/get-list", {
      params: {
        page: currentPage,
        categorySeq: currentCategorySeq,
      }
    }).then((res) => {
      commit(REQUEST_DONATION_GROUP_LIST, res.data)
    })
  },

  requestDonationGroup({commit}, donationGroupSeq) {
    return axiosInst.springAxiosInst.get("/donation-group/get-detail", {
      params: {
        donationGroupSeq: donationGroupSeq
      }
    }).then((res) => {
      commit(REQUEST_DONATION_GROUP, res.data)
    })
  }
}